/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, string,  func, bool,
} from 'prop-types';
import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';
import ClubSelectionDesktop from './ClubSelectionDesktop';
import ClubSelectionMobile from './ClubSelectionMobile';
import { selectedSkuType, skuDataType, UpsellType } from '../common/types';
import GraphqlClubSelectionV2 from '../GraphqlClubSelectionV2/GraphqlClubSelectionV2';

const GraphqlClubSelection = ({
    skuData,
    selectedSku,
    renderSkuPrice,
    skuMonths,
    changeClubMonth,
    changeClubLength,
    tracker,
    clubUpsells,
    changeClubUpsell,
    selectedClubUpsells,
    clubComponents,
    shortDescription,
    longDescription,
    setShippingModalOpen,
    isClubPDPV2,
    product,
    dynamicPriceList,
}) => {
    if (isClubPDPV2) {
        return (
            <GraphqlClubSelectionV2
                skuData={skuData}
                selectedSku={selectedSku}
                renderSkuPrice={renderSkuPrice}
                skuMonths={skuMonths}
                changeClubMonth={changeClubMonth}
                changeClubLength={changeClubLength}
                tracker={tracker}
                clubUpsells={clubUpsells}
                changeClubUpsell={changeClubUpsell}
                selectedClubUpsells={selectedClubUpsells}
                clubComponents={clubComponents}
                shortDescription={shortDescription}
                longDescription={longDescription}
                setShippingModalOpen={setShippingModalOpen}
                product={product}
                dynamicPriceList={dynamicPriceList}
            />
        );
    }
    return (
        <DesktopMobile
            breakpoint={960}
            desktop={() => (

                <ClubSelectionDesktop
                    skuData={skuData}
                    selectedSku={selectedSku}
                    renderSkuPrice={renderSkuPrice}
                    skuMonths={skuMonths}
                    changeClubMonth={changeClubMonth}
                    changeClubLength={changeClubLength}
                    tracker={tracker}
                    clubUpsells={clubUpsells}
                    changeClubUpsell={changeClubUpsell}
                    selectedClubUpsells={selectedClubUpsells}
                    clubComponents={clubComponents}
                    dynamicPriceList={dynamicPriceList}
                />

            )}
            mobile={() => (
                <ClubSelectionMobile
                    skuData={skuData}
                    selectedSku={selectedSku}
                    renderSkuPrice={renderSkuPrice}
                    skuMonths={skuMonths}
                    changeClubMonth={changeClubMonth}
                    changeClubLength={changeClubLength}
                    tracker={tracker}
                    clubUpsells={clubUpsells}
                    changeClubUpsell={changeClubUpsell}
                    selectedClubUpsells={selectedClubUpsells}
                    dynamicPriceList={dynamicPriceList}
                />
            )}
        />
    );
};

GraphqlClubSelection.defaultProps = {
    renderSkuPrice: () => { },
    skuMonths: {},
    clubUpsells: [],
    changeClubMonth: () => { },
    tracker: () => { },
    changeClubLength: () => { },
    changeClubUpsell: () => {},
    selectedClubUpsells: null,
    shortDescription: {},
    longDescription: {},
    setShippingModalOpen: false,
    isClubPDPV2: false,
    product: {},
    dynamicPriceList: null,
};

GraphqlClubSelection.propTypes = {
    renderSkuPrice: func,
    changeClubUpsell: func,
    changeClubMonth: func,
    skuData: skuDataType.isRequired,
    selectedSku: selectedSkuType.isRequired,
    skuMonths: object, // the object contains dynamic keys
    tracker: func,
    changeClubLength: func,
    selectedClubUpsells: string,
    clubUpsells: UpsellType,
    clubComponents: object.isRequired,
    isClubPDPV2: bool,
    shortDescription: object,
    longDescription: object,
    setShippingModalOpen: bool,
    product: object,
    dynamicPriceList: func,
};

export default (GraphqlClubSelection);
